import { render, staticRenderFns } from "./reporteIndividualCobranza.vue?vue&type=template&id=43312486"
import script from "./reporteIndividualCobranza.vue?vue&type=script&lang=js"
export * from "./reporteIndividualCobranza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports